var tracker =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	/*
	import {MindboxTracker} from './mindbox';
	import {DataLayerTracker} from './datalayer';
	import {AdmitAdRetargetingTracker} from './admitad-retargeting';
	import {MailRuTracker} from './mailru';
	import {MailRuNewTracker} from './mailrunew';
	import {GoogleRemarketingTracker} from './google-remarketing';
	import {FacebookTracker} from './facebook';
	import {AdmitAdV2Tracker} from './admitadv2';
	import {AdSpireTracker} from './adspire';
	import {RetailRocket} from './retailrocket';
	import {Addigital} from './addigital';
	import {Vk} from './vk';
	import {AddigitalMgid} from './addigital-mgid';
	import {LeelooTracker} from './leeloo';
	import {Flocktory} from './flocktory';
	import {GoogleRemarketingTag} from './google-remarketing-tag';
	import {WhereElephantCpa} from './where-elephant-cpa';
	import {YandexMetrika} from './yandex-metrika';
	*/
	
	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _retailrocket = __webpack_require__(445);
	
	var _mindboxMindboxTracker = __webpack_require__(444);
	
	var _mindboxMindboxOperation = __webpack_require__(452);
	
	/**
	 * На бекенде инициализируется набор данных для аналитики. Будем использовать его в качестве контейнера для хранения
	 * данных и будем раздавать оттуда данные для аналитических сервисов и CPA партнеров
	 */
	
	var Tracker = (function () {
	    function Tracker(data) {
	        _classCallCheck(this, Tracker);
	
	        this.data = data;
	        this.mindboxTracker = new _mindboxMindboxTracker.MindboxTracker();
	        this.mindboxOperation = new _mindboxMindboxOperation.MindboxOperation();
	        this.retailrocket = new _retailrocket.RetailRocket();
	        this.backendPageViewed();
	    }
	
	    /*
	    constructor(data) {
	      this.data = data;
	      this.dataLayer = new DataLayerTracker(data);
	      this.admitAdRetargeting = AdmitAdRetargetingTracker;
	      //this.mailru = new MailRuTracker();
	      //this.mailrunew = new MailRuNewTracker();
	      this.googleRemarketingTag = new GoogleRemarketingTag();
	      this.admitAdV2 = AdmitAdV2Tracker;
	      //this.AdSpire = AdSpireTracker;
	      this.retailrocket = new RetailRocket();
	      //this.addigital = new Addigital();
	      this.vk = new Vk();
	      //this.addigitalMgit = new AddigitalMgid();
	      //this.leelooTracker = new LeelooTracker();
	      this.flocktory = new Flocktory();
	      this.whereElephantCpa = new WhereElephantCpa();
	      this.yandexMetrika = new YandexMetrika();
	       //this.facebook = new FacebookTracker();
	      //this.mindbox = new MindboxTracker();
	      //this.googleRemarketing = new GoogleRemarketingTracker();
	       this.mindboxTracker = new MindboxTracker();
	       this.mindboxOperation = new MindboxOperation();
	       this.init();
	      this.backendPageViewed();
	    }
	    */
	
	    _createClass(Tracker, [{
	        key: 'init',
	        value: function init() {}
	        //this.admitAdRetargeting.init();
	        //this.dataLayer.init();
	        //this.mailru.init();
	        //this.mailrunew.init();
	        //this.admitAdV2.init();
	        //this.flocktory.init();
	        //this.whereElephantCpa.init();
	
	        // isUserAuthorized() {
	        //     return this.data.user.authorized;
	        // }
	
	    }, {
	        key: 'getCurrency',
	        value: function getCurrency() {
	            return this.data.currency;
	        }
	    }, {
	        key: 'backendPageViewed',
	        value: function backendPageViewed() {
	            switch (this.data.route) {
	                case 'index':
	                    //this.indexPageViewed();
	                    break;
	
	                case 'catalog.product':
	                    this.productPageViewed();
	                    break;
	
	                case 'catalog.section':
	                    this.categoryPageViewed();
	                    break;
	                case 'cart':
	                    this.basketPageViewed();
	                    break;
	            }
	
	            /*switch (this.data.route) {
	            case 'index':
	                this.indexPageViewed();
	                break;
	            case 'products':
	                this.categoryPageViewed();
	                break;
	            case 'product':
	                this.productPageViewed();
	                break;
	            case 'cart':
	                this.basketPageViewed();
	                break;
	            case 'order':
	                this.orderPageViewed();
	                break;
	            // это фейковый маршрут, но страница эта отдельная
	            case 'order.thankyoupage':
	                this.orderThankyouPageViewed();
	                break;
	            // также является фейковым маршрутом
	            case 'encyclopedia_pages.article':
	                this.articlePageViewed();
	                break;
	            case '404':
	                this.notFoundPageViewed();
	                break;
	            case 'search':
	                this.searchPageViewed();
	                break;
	            case 'landing':
	                this.landingPageViewed();
	                break;
	            default:
	                this.otherPageViewed();
	                break;
	            }*/
	        }
	
	        // landingPageViewed() {
	        //     //this.leelooTracker.landingView();
	        // }
	        //
	        // registerPageViewed() {
	        //     this.admitAdRetargeting.registerPageView();
	        //     //this.mailru.otherPageView();
	        //     //this.mailrunew.otherPageView();
	        //     //this.facebook.lead();
	        //     //this.addigitalMgit.otherPageViewed();
	        // }
	
	        // indexPageViewed() {
	        //     this.admitAdRetargeting.indexPageView();
	        //     //this.mailru.indexPageView();
	        //     //this.mailrunew.indexPageView();
	        //     this.googleRemarketingTag.indexPageView();
	        //     //this.addigital.indexPageView();
	        //     //this.addigitalMgit.otherPageViewed();
	        //     this.whereElephantCpa.indexPageView(this.data);
	        //
	        //     //this.googleRemarketing.indexPageView();
	        // }
	
	    }, {
	        key: 'categoryPageViewed',
	        value: function categoryPageViewed() {
	            //this.admitAdRetargeting.categoryPageView(this.data.category);
	            //this.mailru.categoryPageView(this.data.products);
	            //this.mailrunew.categoryPageView(this.data.products);
	            //this.googleRemarketingTag.categoryPageView(this.data.products);
	            //this.dataLayer.categoryPageView(this.data.products);
	            this.retailrocket.viewContentCategory(this.data.category);
	            this.mindboxTracker.categoryView(this.data.category);
	            //this.addigital.categoryPageView();
	            //this.addigitalMgit.otherPageViewed();
	            //this.whereElephantCpa.categoryPageView(this.data)
	
	            //this.facebook.viewContentCategory(this.data.category);
	            //this.googleRemarketing.categoryPageView(this.data.products);
	            //this.mindbox.categoryPageView(this.data.category);
	        }
	    }, {
	        key: 'productPageViewed',
	        value: function productPageViewed() {
	            this.retailrocket.viewContentProduct(this.data.product);
	            this.mindboxTracker.productView(this.data.product);
	            /*
	            this.admitAdRetargeting.productPageView(this.data.product);
	            this.dataLayer.productPageView(this.data.product);
	            //this.mailru.productPageView(this.data.product);
	            //this.mailrunew.productPageView(this.data.product);
	            this.googleRemarketingTag.productPageView(this.data.product);
	            this.retailrocket.viewContentProduct(this.data.product);
	            //this.addigital.productPageView(this.data.product);
	            this.vk.productPageView(this.data.product);
	            //this.addigitalMgit.productPageViewed(this.data.product);
	            //this.leelooTracker.productView();
	            this.whereElephantCpa.productPageView(this.data);
	            //this.facebook.viewContentProduct(this.data.product);
	            //this.googleRemarketing.productPageView(this.data.product);
	            //this.mindbox.productPageView(this.data.product);
	            */
	        }
	    }, {
	        key: 'basketPageViewed',
	        value: function basketPageViewed() {
	            this.dataLayer.basketPageView(this.data.basket);
	            //     this.admitAdRetargeting.basketPageView(this.data.basket);
	            //     this.dataLayer.basketPageView(this.data.basket);
	            //     //this.mailru.basketPageView(this.data.basket);
	            //     //this.mailrunew.basketPageView(this.data.basket);
	            //     //this.addigital.basketPageView(this.data.basket);
	            //     this.vk.basketPageView(this.data.basket);
	            //     //this.addigitalMgit.otherPageViewed();
	            //     this.googleRemarketingTag.basketPageView(this.data.basket);
	            //     this.whereElephantCpa.basketPageView(this.data);
	            //
	            //     //this.googleRemarketing.basketPageView(this.data.basket);
	        }
	
	        //productAddToFavorite(params) {
	        //     //this.facebook.addToWishlist();
	        //     this.dataLayer.push({'event': 'PMbtnWish'});
	        //     this.retailrocket.productAddToFavorite(params);
	        //}
	
	        // orderPageViewed() {
	        //     this.admitAdRetargeting.orderPageView();
	        //     this.dataLayer.orderPageView(this.data.basket);
	        //     //this.mailru.orderPageView();
	        //     //this.mailrunew.orderPageView();
	        //     //this.addigital.orderPageView();
	        //     //this.addigitalMgit.otherPageViewed();
	        //
	        //     //this.facebook.initiateCheckout();
	        //     //this.googleRemarketing.orderPageView();
	        // }
	
	        // orderThankyouPageViewed() {
	        //     this.admitAdRetargeting.orderThankyouPageView(this.data.order, this.data.basket);
	        //     this.dataLayer.orderThankyouPageView(this.data.order, this.data.basket);
	        //     //this.mailru.orderThankyouPageView(this.data.basket);
	        //     //this.mailrunew.orderThankyouPageView(this.data.basket);
	        //     this.admitAdV2.orderThankyouPageView(this.data.order, this.data.basket, this.data.user);
	        //     //this.AdSpire.orderThankyouPageView(this.data.order, this.data.basket, this.data.user);
	        //     this.retailrocket.orderTransaction(this.data.order, this.data.basket, this.data.user);
	        //     //this.addigital.orderThankyouPageView(this.data.basket);
	        //     this.vk.orderThankyouPageView(this.data.basket);
	        //     //this.addigitalMgit.orderThankyouPageView(this.data.basket);
	        //     //this.leelooTracker.orderThankyouPageView();
	        //     this.flocktory.postcheckout(this.data.order, this.data.basket, this.data.user);
	        //     this.googleRemarketingTag.orderCreated(this.data.basket);
	        //
	        //     //this.yandexMetrika.orderComplete(); // не работает
	        //     //this.facebook.purchase(this.data.order);
	        //     //this.facebook.leadOrder(this.data.order);
	        //     //this.googleRemarketing.orderThankyouPageView(this.data.basket);
	        //     //this.mindbox.orderCreated(this.data.order, this.data.basket, this.data.user);
	        // }
	
	        // otherPageViewed() {
	        //     //this.mailru.otherPageView();
	        //     //this.mailrunew.otherPageView();
	        //     //this.addigitalMgit.otherPageViewed();
	        //     this.googleRemarketingTag.otherPageViewed();
	        //     this.whereElephantCpa.otherPageView(this.data);
	        // }
	
	        // notFoundPageViewed() {
	        //     //this.mailru.otherPageView();
	        //     //this.mailrunew.otherPageView();
	        //     this.whereElephantCpa.otherPageView(this.data);
	        // }
	        //
	        // userRegisteredMain(user) {
	        //     this.dataLayer.push({'event': 'Registration_Done'});
	        //     //this.mindbox.userRegistered(user);
	        //     //this.facebook.completeRegistration();
	        // }
	        //
	        // userAuthorizedMain(user) {
	        //     this.flocktory.updateCart(this.data.basket);
	        //     //this.mindbox.userAuthorized(user);
	        // }
	        //
	        // userUpdatedProfilePersonal(user) {
	        //     //this.mindbox.userUpdated(user);
	        // }
	        //
	        // subscriptionChangeClicked() {
	        //     this.dataLayer.push({'event': 'Subscription_Button'});
	        // }
	        //
	        // subscriptionChanged(user) {
	        //     /*if (this.data.route == 'index') {
	        //         this.userSubscribedMainpage(subscription);
	        //     }
	        //     if (this.data.route == 'personal_account') {
	        //         this.userSubscribedProfilePersonal(subscription);
	        //     }*/
	        //     this.dataLayer.push({'event': 'Subscription_Done'});
	        //     //this.mindbox.userChangedSubscription(user);
	        //     //this.facebook.newsletterSubscription();
	        //     this.retailrocket.subscription(user.email);
	        // }
	        //
	        // subscriptionChangedPopup(user) {
	        //     this.dataLayer.push({'event': 'Subscription_Done'});
	        //     this.retailrocket.subscriptionPopup(user.email);
	        // }
	        //
	        // subscriptionPopupForms(email) {
	        //     this.retailrocket.subscription(email);
	        // }
	        //
	        // userSubscribedProfilePersonal(subscription) {
	        //     if (isDevelopment()) {
	        //         //console.log(subscription);
	        //     }
	        // }
	        //
	        // userSubscribedMainpage(subscription) {
	        //     if (isDevelopment()) {
	        //         //console.log(subscription);
	        //     }
	        // }
	
	        /*
	        basketItemAddClicked() {
	          this.dataLayer.push({'event': 'Add2Cart_Button'});
	        }
	        */
	
	    }, {
	        key: 'basketItemAdded',
	        value: function basketItemAdded(product) {
	            this.retailrocket.addToCart(product);
	            this.mindboxOperation.setCart();
	        }
	
	        /*basketItemDeleted(product) {
	            this.mindboxOperation.setCart();
	        }*/
	
	        /* basketUpdate(basketItems) {
	            this.mindboxOperation.setCart();
	        }*/
	        // basketItemUpdated(product) {
	        //     //console.log('basketItemUpdated');
	        //     //console.log(product);
	        //     //this.mindbox.basketItemUpdated(product);
	        // }
	        //
	
	        //
	        // basketPageOpenCouponFormButtonClicked() {
	        //     this.dataLayer.push({'event': 'coupon_link'});
	        // }
	        //
	        // basketPageCouponConfirmClicked() {
	        //     this.dataLayer.push({'event': 'coupon_button'});
	        // }
	        //
	        // basketPageCouponApplied() {
	        //     this.dataLayer.push({'event': 'coupon_Done'});
	        // }
	
	        /*
	        Этих событий нет на сайте сейчас
	        basketPageContinueButtonClicked() {
	          this.dataLayer.push({'event': 'basket_continue'});
	        }
	        basketPageRefreshButtonClicked() {
	          this.dataLayer.push({'event': 'basket_refresh'});
	        }*/
	
	        // basketPageOrderButtonClicked() {
	        //     this.dataLayer.push({'event': 'basket_order'});
	        // }
	        //
	        // oneClickPopupOpened(productId) {
	        //     this.dataLayer.push({'event': 'oneClick_buy_Button'});
	        //     this.dataLayer.push({'event': 'PMfrmOneClick'});
	        //
	        //     if (productId) {
	        //         this.retailrocket.oneClick(productId);
	        //     }
	        // }
	        //
	        // orderPageContactsTabClicked() {
	        //     this.dataLayer.push({'event': 'contact_login'});
	        // }
	        //
	        // orderPageReload() {
	        //     this.dataLayer.orderPageReload(this.data.basket);
	        // }
	        //
	        // orderPageOneClickOrderTabClicked() {
	        //     this.dataLayer.push({'event': 'contact_1clickBuy'});
	        // }
	        //
	        // orderPageConfirmButtonClicked() {
	        //     this.dataLayer.push({'event': 'confirm_order'});
	        // }
	        //
	        // orderPageRegisterTabClicked() {
	        //     this.dataLayer.push({'event': 'contact_registration'});
	        // }
	        //
	        // orderPageLoyalityCardValidated(card) {
	        //     this.dataLayer.orderPageLoyalityCardValidtion(card);
	        // }
	        //
	        // userSubmittedRegistration() {
	        //     this.dataLayer.push({'event': 'contact_registration_continue'});
	        // }
	        //
	        // userSubmittedAuthorization() {
	        //     this.dataLayer.push({'event': 'contact_login_continue'});
	        // }
	        //
	        // orderPageOneClickOrderButtonClicked() {
	        //     this.dataLayer.push({'event': 'contact_1clickBuy_continue'});
	        //     //this.facebook.buyOneClick();
	        // }
	
	        /*orderCreated() {
	          this.debug('orderCreated');
	        }
	        orderCreatedOneClick() {
	          this.debug('orderCreatedOneClick');
	        }*/
	
	        // productSubscribed(product, user) {
	        //     //this.mindbox.productSubscribed(product, user);
	        // }
	        //
	        // callbackFormOpened() {
	        //     this.dataLayer.push({'event': 'backcall'});
	        //     this.dataLayer.push({'event': 'PMbtnCallMe'});
	        // }
	        //
	        // callbackFormSended() {
	        //     this.dataLayer.push({'event': 'backcall_sent'});
	        //     this.dataLayer.push({'event': 'PMfrmCallMe'});
	        //     //this.facebook.requestCallBack();
	        // }
	        //
	        // onlineChatOpened() {
	        //     this.dataLayer.push({'event': 'online_consultant'});
	        // }
	        //
	        // onlineChatMessageSended() {
	        //     this.dataLayer.push({'event': 'online_consultant_button'});
	        // }
	        //
	        // productDescriptionTabOpened() {
	        //     this.dataLayer.push({'event': 'description_tab'});
	        // }
	        //
	        // productAccessoriesTabOpened() {
	        //     this.dataLayer.push({'event': 'accessories_tab'});
	        // }
	        //
	        // productReviewsTabOpened() {
	        //     this.dataLayer.push({'event': 'reviews_tab'});
	        // }
	        //
	        // productFaqTabOpened() {
	        //     this.dataLayer.push({'event': 'faq_tab'});
	        // }
	        //
	        // productAnalogsTabOpened() {
	        //     this.dataLayer.push({'event': 'analogues_tab'});
	        // }
	        //
	        // shopsMapOpened() {
	        //     this.dataLayer.push({'event': 'offline_map'});
	        // }
	        //
	        // clickButtonApplySmartFilter() {
	        //     this.dataLayer.push({'event': 'PMbtnFilter'});
	        //     //this.facebook.applyingFilter();
	        // }
	        //
	        // tooltipProduct(type) {
	        //     if (type) {
	        //         let eventName;
	        //         switch (true) {
	        //             case (type === 'delivery'):
	        //                 eventName = 'PMbtnDelivery';
	        //                 break;
	        //             case (type === 'cards'):
	        //                 eventName = 'PMbtnBonus';
	        //                 break;
	        //         }
	        //
	        //         this.dataLayer.push({'event': eventName});
	        //     }
	        // }
	
	        // reviewsAdd() {
	        //     this.dataLayer.push({'event': 'PMfrmComment'});
	        //     //this.facebook.addReview();
	        // }
	        //
	        // questionsAdd() {
	        //     this.dataLayer.push({'event': 'PMfrmAsk'});
	        //     //this.facebook.addQuestion();
	        // }
	        //
	        // productNotificationAdd() {
	        //     this.dataLayer.push({'event': 'PMfrmNotice'});
	        //     //this.facebook.productNotificationAdd();
	        // }
	        //
	        // selectedCity(cityName) {
	        //     this.dataLayer.push({
	        //         'event': 'PMbtnCity',
	        //         'pmParam1': cityName.replace(/&quot;/g, ''),
	        //     });
	        // }
	
	        // clickPointYandexMap(shopName) {
	        //     this.dataLayer.push({
	        //         'event': 'PMbtnCityItem',
	        //         'pmParam1': shopName.replace(/&quot;/g, ''),
	        //     });
	        //
	        //     //this.facebook.selectedShop();
	        // }
	        //
	        // clickPhoneBox() {
	        //     this.dataLayer.push({'event': 'PMbtnTel'});
	        // }
	        //
	        // clickSocialNetwork() {
	        //     //this.facebook.clickSocialNetwork();
	        // }
	    }]);
	
	    return Tracker;
	})();

	exports.Tracker = Tracker;

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(60);
	var core = __webpack_require__(61);
	var ctx = __webpack_require__(62);
	var hide = __webpack_require__(64);
	var has = __webpack_require__(74);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),

/***/ 60:
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ 61:
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(63);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),

/***/ 63:
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(65);
	var createDesc = __webpack_require__(73);
	module.exports = __webpack_require__(69) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(66);
	var IE8_DOM_DEFINE = __webpack_require__(68);
	var toPrimitive = __webpack_require__(72);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(69) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(67);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),

/***/ 67:
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(69) && !__webpack_require__(70)(function () {
	  return Object.defineProperty(__webpack_require__(71)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(70)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),

/***/ 70:
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(67);
	var document = __webpack_require__(60).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(67);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),

/***/ 73:
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),

/***/ 74:
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(112);

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(113);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(114), __esModule: true };

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(115);
	var $Object = __webpack_require__(61).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(59);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(69), 'Object', { defineProperty: __webpack_require__(65).f });


/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(117);

/***/ }),

/***/ 117:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var MindboxTracker = (function () {
	    function MindboxTracker() {
	        _classCallCheck(this, MindboxTracker);
	    }
	
	    _createClass(MindboxTracker, [{
	        key: 'operationSend',
	        value: function operationSend(operation, data) {
	            window.mindbox('async', {
	                operation: operation,
	                data: data,
	
	                onSuccess: function onSuccess() {
	                    console.info('OK MindboxTracker ' + operation + ': %o', data);
	                },
	                onError: function onError(error) {
	                    console.error('ERROR MindboxTracker: ' + operation + ' ' + error);
	                }
	            });
	        }
	
	        /**
	         * Трекер раздела товаров+
	         * @param category
	         */
	    }, {
	        key: 'categoryView',
	        value: function categoryView(category) {
	            this.operationSend('CategoryView', {
	                viewProductCategory: {
	                    productCategory: {
	                        ids: {
	                            smartBuy: category.id
	                        }
	                    }
	                }
	            });
	        }
	
	        /**
	         * Трекер детальной страницы товара+
	         * @param product
	         */
	    }, {
	        key: 'productView',
	        value: function productView(product) {
	            this.operationSend('ProductView', {
	                viewProduct: {
	                    price: product.price,
	                    product: {
	                        ids: {
	                            smartBuy: product.vendorCode
	                        }
	                    }
	                }
	            });
	        }
	
	        /**
	         * Трекер добавления товара в корзину-
	         * @param basketData
	         */
	    }, {
	        key: 'setCart',
	        value: function setCart(basketData) {
	            this.operationSend('SetCart', basketData);
	        }
	
	        /**
	         * Трекер добавления товара в избранное+
	         * @param productsData
	         */
	    }, {
	        key: 'setWishList',
	        value: function setWishList(productsData) {
	            this.operationSend('SetWishList', productsData);
	        }
	
	        /**
	         * Трекер авторизации пользователя+
	         * @param phone
	         */
	    }, {
	        key: 'authorization',
	        value: function authorization(phone) {
	            this.operationSend('Authorization', {
	                customer: {
	                    mobilePhone: phone
	                }
	            });
	        }
	    }]);
	
	    return MindboxTracker;
	})();

	exports.MindboxTracker = MindboxTracker;

/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var RetailRocket = (function () {
	    function RetailRocket() {
	        _classCallCheck(this, RetailRocket);
	    }
	
	    _createClass(RetailRocket, [{
	        key: 'track',
	        value: function track(callback) {
	            (window['rrApiOnReady'] = window['rrApiOnReady'] || []).push(function () {
	                try {
	                    callback();
	                } catch (e) {
	                    if (false) {
	                        console.log(e);
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'viewContentProduct',
	        value: function viewContentProduct(product) {
	            if (!product) {
	                return;
	            }
	
	            var callback = undefined;
	            if (product.is_offers) {
	                callback = function () {
	                    rrApi.groupView(product.offers_id);
	                };
	            } else {
	                callback = function () {
	                    rrApi.view(product.id);
	                };
	            }
	
	            this.track(callback);
	        }
	    }, {
	        key: 'viewContentCategory',
	        value: function viewContentCategory(category) {
	            if (!category) {
	                return;
	            }
	
	            this.track(function () {
	                rrApi.categoryView(category.id);
	            });
	        }
	    }, {
	        key: 'setProfile',
	        value: function setProfile(params) {
	            if (!params) {
	                return;
	            }
	
	            this.track(function () {
	                rrApi.setProfile(params);
	            });
	        }
	
	        /*
	        subscription(email) {
	            this.track(function() {
	                rrApi.setEmail(email);
	                rrApi.welcomeSequence(email);
	            });
	        }
	           subscriptionPopup(email) {
	            this.track(function() {
	                rrApi.setEmail(email, {EmailPopUp: true});
	                rrApi.welcomeSequence(email);
	            });
	        }
	           oneClick(productId) {
	            this.track(function() {
	                rrApi.addToBasket(productId);
	            });
	        }
	        */
	
	    }, {
	        key: 'addToCart',
	        value: function addToCart(product) {
	            this.track(function () {
	                rrApi.addToBasket(product.id);
	            });
	        }
	    }, {
	        key: 'orderTransaction',
	        value: function orderTransaction(order, basket) {
	            var params = {
	                transaction: order.id,
	                items: this.formatBasket(basket)
	            };
	            this.track(function () {
	                rrApi.order(params);
	            });
	        }
	
	        /*
	        productAddToFavorite(params) {
	            this.track(function() {
	                rrApi.subscribeonpricedrop(params.email, [params.product]);
	            });
	        }
	        */
	
	    }, {
	        key: 'formatBasket',
	        value: function formatBasket(basket) {
	            return basket.map(function (basketItem) {
	                return RetailRocket.formatBasketItem(basketItem);
	            });
	        }
	    }], [{
	        key: 'formatBasketItem',
	        value: function formatBasketItem(basketItem) {
	            return {
	                id: basketItem.offer_id || basketItem.id,
	                qnt: parseFloat(basketItem.quantity),
	                price: parseFloat(basketItem.price)
	            };
	        }
	    }]);
	
	    return RetailRocket;
	})();

	exports.RetailRocket = RetailRocket;

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = __webpack_require__(111)['default'];
	
	var _classCallCheck = __webpack_require__(116)['default'];
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _mindboxTracker = __webpack_require__(444);
	
	var MindboxOperation = (function () {
	    function MindboxOperation() {
	        _classCallCheck(this, MindboxOperation);
	
	        this.mindboxTracker = new _mindboxTracker.MindboxTracker();
	    }
	
	    _createClass(MindboxOperation, [{
	        key: 'setCart',
	        value: function setCart() {
	            var _self = this;
	            $.ajax({
	                url: '/ajax/action/widget_mindbox_operation_basket/get_data/',
	                type: 'GET',
	                success: function success(result) {
	                    if (parseInt(result.code) === 200) {
	                        _self.mindboxTracker.setCart(result.data);
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'setWishList',
	        value: function setWishList() {
	            var _self = this;
	            $.ajax({
	                url: '/ajax/action/widget_mindbox_operation_favorite/get_data/',
	                type: 'GET',
	                success: function success(result) {
	                    if (parseInt(result.code) === 200) {
	                        _self.mindboxTracker.setWishList(result.data);
	                    }
	                }
	            });
	        }
	    }]);
	
	    return MindboxOperation;
	})();

	exports.MindboxOperation = MindboxOperation;

/***/ })

/******/ });


// WEBPACK FOOTER //
// js/tracker.1b62c2e74a003b5625f7.js